<div id="user-top-dropdown" class="dropdown">
  <button class="btn {{'VIEWS.user-top-dropdown.btn-color' | translate}} dropdown-toggle d-flex align-items-center"
    type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false"
    (click)="toggleDropdown()">
    <label *ngIf="screenWidth>=992">Profile</label>
    <mat-icon *ngIf="screenWidth < 992">account_circle</mat-icon>
  </button>
  <ul id="dropdown" class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton"
    [ngClass]="{
      'd-block': opened,
      'd-none': !opened
    }"
    appClickOutside 
    (appClickOutside)="closeDropdown()"
    appanimatecss="animate__fadeIn">
    <ng-container *featuretoggle="changePasswordFeatureToggle">
      <li *ngIf="!(elevatedAccess$ | async)"><a class="dropdown-item d-flex align-items-center p-2 click"
          [routerLink]="'/change-password'">
          <mat-icon class="me-3">lock</mat-icon>
          Change password
        </a>
      </li>
    </ng-container>
    <li *ngIf="!inIframe()">
      <a class="dropdown-item d-flex align-items-center p-2 signout click" (click)="signout()">
        <mat-icon class="me-3">exit_to_app</mat-icon>
        Sign out
      </a>
    </li>

  </ul>
</div>
